<div class="col-sm-12">

  <h3 class="text-light-blue">
    Meses relacionados ao filtro de <b>{{ this.periodoInicial | date:'dd/MM/yyyy' }}</b> até <b>{{ this.periodoFinal | date:'dd/MM/yyyy' }}</b>
    
    <button class="btn btn-sm btn-danger pull-right" (click)="gotoAnaliseContasReport(listaCronogramaDesembolso)"><i class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button>
  </h3>

  <div *ngIf="!loading">
    <div class="spinner"></div>
    <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando relatório, por favor aguarde ...
    </p>
  </div>

  <div *ngIf="loading">

  <table class="table">
    <tbody>
      <tr *ngFor="let item of listaCronogramaDesembolso">
        <td>
          <h3><b style="text-transform: uppercase;">{{item.mes | date: 'MMMM/yyyy'}}</b></h3>
          
          <div *ngFor="let meta of item.metas" style="padding: 10px 0;">
            
            <b><p class="text-light-blue">{{meta.descricao}}</p></b>
          
            <div *ngFor="let etapa of meta.etapas" style="margin: 10px 0 10px 10px; background-color: #eee; padding: 10px 10px; border-radius: 5px;">
              <p style="margin-bottom: 0;"><b>{{etapa.especificacao}}</b><br>
                 <small class="text-muted">Período de <b>{{etapa.dataIni | date: 'dd/MM/yyyy'}}</b> até <b>{{etapa.dataFim | date: 'dd/MM/yyyy'}}</b></small>
              </p>
              
              <ul class="tree" style="margin-bottom: 0;">
                <li>Indicador: {{etapa.descricao}}</li>
              </ul>
              
              <div style="margin: 5px 0 5px 0;" *ngIf="etapa.evidenciasHasMeta.length>0">
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <th>Evidência</th>
                      <th class="text-center" style="width: 90px">Percentual</th>
                      <th style="width: 40px">Ocorrência</th>
                    </tr>
                    <tr *ngFor="let evidencia of etapa.evidenciasHasMeta">
                      <td>{{evidencia.descricao}}</td>
                      <td class="text-center">{{evidencia.porcentagem || 0}}%</td>
                      <td>{{evidencia.dataOcorrencia | date: 'dd/MM/yyyy'}}</td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>

        </td>
      </tr>
    </tbody>
  </table>

  </div>

</div>

<br>
<br>